import React, { useState } from "react";
import { AddContainer } from "./style";
import { CloseableArea } from "../../../components/closeableArea";

export const AddButton = props => {
  const [active, setActive] = useState(false);
  const { title, onClick, menuBar } = props;

  return (
    <AddContainer
      status={active}
      hasShadow={props.hasShadow}
      expand={props.expand}
      disable={props.disable}
      style={props.style}
    >
      {menuBar && (
        <CloseableArea show={active} focus onClose={() => setActive(!active)} />
      )}
      <div className={`add-button`}>
        {menuBar && (
          <div className="expandable">
            <ul>
              {menuBar.items.map((item, i) => {
                let separator = <div />;
                if (i !== menuBar.items.length - 1) {
                  separator = <div className="addButtonSeparator" />;
                }
                return (
                  <React.Fragment key={i}>
                    <div
                      onClick={() => item.onClick()}
                      title={item.title}
                      className="add-menu-item"
                    >
                      <li>
                        <i className={`icon ${item.icon} `} />
                        <span
                          className="text-item"
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                      </li>
                    </div>
                    {separator}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        )}
        <div
          className="button-text"
          onClick={menuBar ? () => setActive(!active) : () => onClick()}
        >
          <i className="icon mapsa-plus"> </i>
          <span className="add-button-text no-select">{title}</span>
        </div>
      </div>
    </AddContainer>
  );
};
